import React from 'react'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'

import { Maybe, TravelTypeEnum } from '../../../lib/graphql'
import { useDateFormatter } from '../../../lib/hooks'
import { capitalizeFirstLetter, getFormattedDate } from '../../../utils'

type EventInformationProps = {
  contactFirstname?: Maybe<string>
  contactLastname?: Maybe<string>
  endDate?: Maybe<Date>
  startDate?: Maybe<Date>
  travelType?: Maybe<TravelTypeEnum>
}

const getTravelTypeLabel = (
  intl: IntlShape,
  travelType?: Maybe<TravelTypeEnum>,
) => {
  switch (travelType) {
    case TravelTypeEnum.NIGHTLY_TRIP:
      return intl.formatMessage({
        id: 'ui.TravelTypePicker.label.nightlyTripTag',
        defaultMessage: 'Séminaire résidentiel',
      })
    case TravelTypeEnum.DAILY_TRIP:
      return intl.formatMessage({
        id: 'ui.TravelTypePicker.label.dailyTripTag',
        defaultMessage: 'Séminaire à la journée',
      })
    case TravelTypeEnum.CORPORATE_EVENING_EVENT:
      return intl.formatMessage({
        id: 'ui.TravelTypePicker.label.corporateEveningEventTag',
        defaultMessage: "Soirée d'entreprise",
      })
    default:
      return ''
  }
}

export const EventInformation = ({
  travelType,
  startDate,
  endDate,
  contactFirstname,
  contactLastname,
}: EventInformationProps) => {
  const intl = useIntl()
  const dateFormatter = useDateFormatter()

  const dates = getFormattedDate({
    startDate,
    endDate,
    formatter: dateFormatter,
  })
  const travelTypeLabel = getTravelTypeLabel(intl, travelType)

  return (
    <div className='mt-3 w-full text-xs text-grey-800'>
      <p>{`${travelTypeLabel} ${dates}`}</p>
      <p className='min-h-6 pt-2'>
        {contactFirstname && (
          <FormattedMessage
            id='ui.EventInformation.organizedBy'
            defaultMessage='Organisé par <strong>{firstname} {lastname}</strong>'
            values={{
              firstname: capitalizeFirstLetter(contactFirstname),
              lastname: contactLastname
                ? capitalizeFirstLetter(contactLastname)
                : '',
              strong: (chunks) => (
                <strong className='font-medium'>{chunks}</strong>
              ),
            }}
          />
        )}
      </p>
    </div>
  )
}
